"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDailySummaryPerformanceCreative = exports.createDailySummaryPerformanceBasis = exports.createDailySummaryPerformance = void 0;
const creation_1 = require("../creation");
const DailyPerformanceValue_1 = require("../DailyPerformanceValue/DailyPerformanceValue");
const performanceReportPeriod_1 = require("./performanceReportPeriod");
const createDailySummaryPerformance = () => ({
    period: performanceReportPeriod_1.createPerformanceReportPeriod(),
    basis: exports.createDailySummaryPerformanceBasis(),
    metric: 'click_through_rate',
    creatives: [exports.createDailySummaryPerformanceCreative()],
});
exports.createDailySummaryPerformance = createDailySummaryPerformance;
const createDailySummaryPerformanceBasis = () => ({
    values: [DailyPerformanceValue_1.createDailyPerformanceValue()],
});
exports.createDailySummaryPerformanceBasis = createDailySummaryPerformanceBasis;
const createDailySummaryPerformanceCreative = (object = {
    creativeId: '',
    creation: creation_1.createSomeCreation(),
    values: [DailyPerformanceValue_1.createDailyPerformanceValue()],
    adName: '',
    thumbnailImageUrl: '',
}) => object;
exports.createDailySummaryPerformanceCreative = createDailySummaryPerformanceCreative;
